module.exports = __webpack_public_path__ + "img/logo-wandr_e-white.edf37243.svg";